import {clone, isString} from "lodash";
import {spawnTstzSpan, TstzSpan} from "../tstzspan.ts";
// import {RpcType, RpcTypeMap, SortOrder} from "../rpc/webrpc-client.gen.ts";
import {faSortAsc, faSortDesc} from "@fortawesome/pro-regular-svg-icons";
import {Ided} from "../util/arutil.tsx";
import {replaceLetter, SealedLetter} from "../util/zodhelp.ts";

// const TQDEADBEEF = "TQDEADBEEF";
//
// const TQDEADBEEF_KEY = [TQDEADBEEF];
//
// export const DEADBEEF_QUERY_OPTS = {
//     queryKey: TQDEADBEEF_KEY,
//     queryFn: skipToken,
// } as const;
//
// export type DeadbeefQueryKey<VerbT extends string> = [VerbT, typeof TQDEADBEEF];
// export function deadbeefQueryKey<VerbT extends string>(verb: VerbT): DeadbeefQueryKey<VerbT> {
//     return [verb, TQDEADBEEF];
// }

// export const NOP_MUTATION_OPTS = {
//     mutationKey: ["NOP"],
//     mutationFn() {
//         throw new Error("should never happen")
//     }
// }

// export class RefreshSet {
//     queryFilters: QueryFilters[];
//
//     public constructor(qfilters: QueryFilters[]) {
//         this.queryFilters = [...qfilters];
//     }
//
//     public invalidate(): Promise<unknown> {
//         return Promise.all(this.queryFilters.map(qf =>
//             GLOBAL_QUERY_CLIENT.invalidateQueries(qf)));
//     }
//
//     public addSingle(qfilter: QueryFilters) {
//         this.queryFilters.push(qfilter);
//     }
//
//     public add(food: RefreshSet | QueryFilters[]) {
//         if (isArrayLike(food)) {
//             this.queryFilters.push(...food);
//         } else {
//             this.queryFilters.push(...food.queryFilters);
//         }
//     }
//
//     public removeSingle(qfilter: QueryFilters) {
//         const ix = this.queryFilters.findLastIndex((maybe) => {
//             const rv = isEqual(maybe, qfilter);
//             return rv;
//         });
//         if (ix < 0) {
//             console.log(`refresh set underflow ${JSON.stringify(qfilter)}`);
//         } else {
//             this.queryFilters.splice(ix, 1);
//         }
//     }
//
//     public remove(qfilters: QueryFilters[]) {
//         qfilters.forEach(qfilter => {
//             this.removeSingle(qfilter);
//         });
//     }
// }

// export const NULLFUNC = () => {
//     /**/
// }

// // export type LimitedUseQueryOptions<T = unknown> = T & {
// //     enabled?: boolean;
// //     staleTime?: number;
// // }
//
// export type LimitedUseQueryOptions<
//     TQueryFnData = unknown,
//     TError = DefaultError,
//     TData = TQueryFnData,
//     TQueryKey extends QueryKey = QueryKey,
// > = UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>;
//
// //
// // export type LimitedUseQueryResult<T> =
// //     { isSuccess: true; data: T; } | { isSuccess: false; data?: T | undefined; };
//
// export type LimitedUseQueryResult<TData = unknown, TError = DefaultError>
//     = UseQueryResult<TData, TError>;
//
// const _MADA: QueryObserverPendingResult = {
//     isSuccess: false,
//     data: undefined,
//     error: null,
//     isError: false,
//     isPending: true,
//     isLoadingError: false,
//     isRefetchError: false,
//     isPlaceholderData: false,
//     status: "pending",
//     dataUpdatedAt
// } as const;
//
// export function MADA<TData = unknown, TError = DefaultError>(): QueryObserverPendingResult<TData, TError> {
//     return _MADA;
// }
//
// const afo: LimitedUseQueryResult<number>
//
// export const EMPTY_LIST = {data: [], isSuccess: true};
// export const EMPTY = {};
// export const NOPE = {isSuccess: true, data: null};


// "0" being truthy causes lots of problems, so don't use remeda directly
export function isTruthy(maybe: undefined | null | string | number | boolean): maybe is true {
    if (!maybe) {
        return false;
    }
    if (isString(maybe)) {
        const c1 = maybe.charAt(0);
        switch (c1) {
            case "t":
            case "T":
            case "1":
            case "y":
            case "Y":
                return true;
            default:
                return false;
        }
    }
    return !!maybe;
}

export function strToFixedPoint(str: string | null | undefined, decPlaces: number): number | undefined {
    if (!str) {
        return undefined;
    }
    const fprv = Number.parseFloat(str);
    return Math.round(fprv * Math.pow(10, decPlaces));
}

export function fixedPointToStr(fixpt: number | undefined | null, decPlaces: number): string {
    if (fixpt === undefined || fixpt === null) {
        return "";
    }
    const floatrv = fixpt / Math.pow(10, decPlaces);
    return floatrv.toString();
}

export function isActive(maybe: { validSpan: TstzSpan | string }): boolean {
    const validSpan = spawnTstzSpan(maybe.validSpan)
    return validSpan.valid && validSpan.contains(new Date());
}

export function performDownload({data, filename}: { data: unknown, filename: string }) {
    const jso = JSON.stringify(data);
    const blob = new Blob([jso], {type: "application/json"});
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("href", url);
    a.setAttribute("download", filename);
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    return Promise.resolve(jso);
}

// export function denseMap<FromT, ToT>(froms: FromT[] | undefined, mapper: (from: FromT) => ToT | undefined): ToT[] {
//     const rv: ToT[] = [];
//     if (froms) {
//         for (const from of froms) {
//             const maybeTo = mapper(from);
//             if (maybeTo !== undefined) {
//                 rv.push(maybeTo);
//             }
//         }
//     }
//     return rv
// }
//
// interface UseDenseMapState<FromT, ToT> {
//     froms: FromT[] | undefined;
//     tos: ToT[];
// }
//
// // stabilizes referential integrity of denseMap
// export function useDenseMap<FromT, ToT>(froms: FromT[] | undefined, mapper: (from: FromT) => ToT | undefined): ToT[] {
//     const [state, setState] = useState<UseDenseMapState<FromT, ToT>>({froms: undefined, tos: NADA});
//     const next = denseMap(froms, mapper);
//     // useWhatChanged([froms, next, state.tos]);
//     useEffect(() => {
//         if (!isEqual(state.tos, next)) {
//             setState({froms, tos: next});
//         }
//     }, [froms, next, state.tos]);
//     return state.tos;
// }

// function bogusPromise<T>(): Promise<T> {
//     return Promise.resolve() as Promise<T>;
// }
//
// // eslint-disable-next-line @typescript-eslint/no-unused-vars
// function useBogusQueries<T>() {
//     return useQueries({queries: [
//         queryOptions({queryKey: ["bogus"], queryFn: () => bogusPromise<T>()})
//     ]})
// ')

// export function transformUseQueryResult<FromT, ToT, ErrorT>({from, tf}: {
//     from: UseQueryResult<FromT, ErrorT>,
//     tf: (from: FromT | undefined) => ToT
// }) {
//     return {...from, data: tf(from.data)};
// }

// export function mergeUseQueryResults<T, TError>(tqrvs: UseQueryResult<T, TError>[]) {
//     const prv = {
//         data: [] as T[],
//         isError: false,
//         isPending: false,
//         isSuccess: true,
//         error: null as (null | TError),
//     };
//
//     // abusing find for its short circuit return feature
//     tqrvs.find((tqrv, ix) => {
//         switch (tqrv.status) {
//             case "success":
//                 prv.data[ix] = tqrv.data;
//                 return false;
//             case "pending":
//                 prv.isPending = true;
//                 return true;
//             case "error":
//                 prv.isError = true;
//                 prv.error = tqrv.error;
//                 return true;
//         }
//     });
//
//     if (prv.isPending) {
//         const pendingRv: QueryObserverPendingResult<T, TError> = {
//             data: undefined,
//         };
//     }
//
//
//     for (const tqrv of tqrvs) {
//         if (!tqrv.isSuccess) {
//             // if (tqrvs.length > 0) {
//             //     console.log(`mada on ${JSON.stringify(tqrvs)}`);
//             // }
//             return MADA;
//         } else {
//             data.push(tqrv.data);
//         }
//     }
//     // if (tqrvs.length > 0) {
//     //     console.log(`success on ${JSON.stringify(tqrvs)}: ${JSON.stringify(data)}`);
//     // }
//     return {data, isSuccess: true};
// }

// the mapper can act as a filter. if it returns undefined even though the underlying
// query result is successful, the result is not added to data. however, all rib
// queries must settle successfully for the whole thing to do so.

// export function mergeMapUseQueryResults<FromT, ToT>(tqrvs: UseQueryResult<FromT>[], mapper: (from: FromT) => ToT | undefined): LimitedUseQueryResult<ToT[]> {
//     const data: ToT[] = [];
//     for (const tqrv of tqrvs) {
//         if (!tqrv.isSuccess) {
//             return MADA;
//         } else {
//             const mapped = mapper(tqrv.data);
//             if (mapped !== undefined) {
//                 data.push(mapped);
//             }
//         }
//     }
//     return {data, isSuccess: true};
// }

// TQ useQueries combiners are dependencies, so you have to take great care
// to keep them referentially stable or they are infinite render traps.

// export function useMappingMergeUseQueryResultCombiner<T, RPCT>(mapper: (rpc: RPCT) => T | undefined) {
//     const combiner = useCallback((results: UseQueryResult<RPCT>[]) =>
//         mergeMapUseQueryResults<RPCT, T>(results, mapper), [mapper]);
//     return combiner;
// }

// export function makeFanoutQueryFn<T, StubT, RibRpcT>(
//     ribqoCreche: (stub: StubT) => EnsureQueryDataOptions<RibRpcT, DefaultError, T>
// ) {
//     return (stubs: StubT[]) => Promise.all(stubs.map(stub => ribqoCreche(stub)));
// }

// export const UNFED_STALE_TIME = 5 * 60 * 1000;
// export const FED_STALE_TIME = Infinity;

// this is not using the enum in order to help with typing in the toggle bar
export const sortOrderIcons = {
    ASC: faSortAsc,
    DESC: faSortDesc,
} as const;

export interface Transition<T> {
    prev: T;
    next: T;
}

export function applyPatch<T extends Ided>(prev: T, trans: Transition<Partial<T>>): Partial<T> {
    const next = clone(prev) as Record<string, any>;
    for (const k in trans.prev) {
        if (k !== "id") {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete (next[k]);
        }
    }
    for (const k in trans.next) {
        if (k !== "id") {
            next[k] = trans.next[k];
        }
    }
    const rv = next as T;
    return rv;
}

export function patchSingleLetter<Envelope extends string, LetterT extends Ided>(orig: SealedLetter<Envelope, LetterT>, trans: Transition<Partial<LetterT>>): SealedLetter<Envelope, Partial<LetterT>> {
    const k0 = Object.keys(orig)[0] as Envelope;
    const prevLetter = orig[k0];
    const nextLetter = applyPatch(prevLetter, trans);
    const next = replaceLetter(orig, nextLetter);
    return next;
}

 // export type TqCacheSpy = ReturnType<QueryCache.prototype.subscribe>

// type TqCacheSpyEntry<T> = [string, TqCacheListener<T>];
// type SomeCacheSpy = <R>(cb: <T>(listener: TqCacheListener<T>) => TqCacheSpyEntry<T>) => R;
// const someCacheSpy = <T,>(entry: CacheSpyEntry<T>): SomeCacheSpy =>
//     (maker) => maker(entry);
//
// const afospy: TqCacheListener<WatchBundleByIdReturn> = (evt: TqCacheNotifyEvent<WatchBundleByIdReturn>) => {
//     console.log(evt.type);
// }
//
// const bfospy: SomeCacheSpy = someCacheSpy(makeBundleByIdCacheSpyEntry(afospy));
// const hohi = bfospy();
//
// type QueryKeyTypeForTqo<TQO extends (...args: any) => {queryKey: QueryKey}> = ReturnType<TQO>["queryKey"];
// type QueryFnReturnTypeForTqo<RVT, TQO extends (...args: any) => {queryFn: (...args: any) => RVT}> =
//     Exclude<ReturnType<NonNullable<ReturnType<TQO>["queryFn"]>>, Promise<any>>;
//
// type SingleArgTqk<VerbT extends string, ArgT> = [VerbT] | [VerbT, ArgT];
// type SingleArgTqkMaker<VerbT extends string, ArgT> = (arg: ArgT) => SingleArgTqk<VerbT, ArgT>;
//
// type BundleByIdQueryKey = QueryKeyTypeForTqo<typeof watchBundleByIdTqo>;
// type BundleByIdTqorv = QueryFnReturnTypeForTqo<any, any>;
//
// type afot =  ReturnType<typeof watchBundleByIdTqo>["queryFn"];
//
// export type CacheSpiesByVerb = {
//     [verb: string]: TqCacheListener<any> | undefined;
// };
//
// export function extractQueryKeyArg(tqk: VerbedQueryKey, argname: string) {
//     if (isString(tqk[1])) {
//         const qp = new URLSearchParams(tqk[1]);
//         const rv = qp.get(argname);
//         return rv;
//     }
// }
//
// export function watchTqCacheByVerb({tqc, spies}: { tqc: QueryClient, spies: TqCacheSpySet }): Unlistener {
//     const cache = tqc.getQueryCache();
//     const spiesByVerb = spies as { [verb: string]: TqCacheListener<unknown> | undefined };
//
//     return cache.subscribe((tqevt: QueryCacheNotifyEvent) => {
//         const update = tqevt.type === "updated" && tqevt.action.type === "success"
//             ? {
//                 query: tqevt.query as Query<unknown, DefaultError, unknown, VerbedQueryKey>,
//                 data: tqevt.action.data as unknown,
//                 dataUpdatedAt: tqevt.action.dataUpdatedAt,
//                 manual: tqevt.action.manual,
//             }
//             : undefined;
//
//         if (update) {
//             const tqk = update.query.queryKey;
//             const verb = tqk[0];
//             if (isString(verb)) {
//                 const spy = spiesByVerb[verb];
//                 if (spy) {
//                     spy(update);
//                 }
//             }
//         }
//     });
// }

// type CombinableResult<CombinedT, ErrorT> = {
//     [P in keyof CombinedT]: Result<CombinedT[P], ErrorT>;
// }
//
// type CombinedErrors<CombinedT, ErrorT> = {
//     [P in keyof CombinedT]?: ErrorT;
// }
//
// export function combineResult<TypeMapT, ErrorT = Error>(from: CombinableResult<TypeMapT, ErrorT>)
//     : Result<TypeMapT, CombinedErrors<TypeMapT, ErrorT>> {
//     const rv = {} as TypeMapT;
//     const errors: CombinedErrors<TypeMapT, ErrorT> = {};
//     for (const k in from) {
//         const v = from[k];
//         if (v.isPending) {
//             return pendingResult;
//         }
//         if (v.isError) {
//             errors[k] = v.error;
//         } else {
//             rv[k] = v.data;
//         }
//     }
//     if (Object.keys(errors).length > 0) {
//         return errorResult(errors);
//     }
//     return successResult(rv);
// }
//

// const as = z.strictObject({
//     pkid: z.string(),
//     tbl: z.string(),
//     asof: z.string(),
//     tqks: z.string().array(),
// });
//
// const bs = z.strictObject({
//     pkid: z.string(),
//     tbl: z.string(),
//     asof: z.string(),
//     tqks: z.string().array(),
//     prev: z.looseObject({}),
// });
//
// const cs = z.strictObject({
//     pkid: z.string(),
//     tbl: z.string(),
//     asof: z.string(),
//     tqks: z.string().array(),
//     next: z.looseObject({}),
// });
//
// const ds = z.strictObject({
//     pkid: z.string(),
//     tbl: z.string(),
//     asof: z.string(),
//     tqks: z.string().array(),
//     dlta: z.literal(true),
//     prev: z.looseObject(Ided.shape),
//     next: z.looseObject(Ided.shape),
// });
//
// const abcs = z.union([as, bs, cs, ds]);
// type abct = z.infer<typeof abcs>;
//
// const afo: abct = {
//     pkid: "43",
//     tbl: "hi",
//     asof: "now",
//     tqks: ["hi"],
//     dlta: true,
// } as const;
// console.log(afo);
//
//
// export function isRpcType(t: string | undefined): t is RpcType {
//     return !!t && t in RpcTypeMap;
//}

